import { useReducer, useEffect } from 'react';
import { isSSR } from '@front10/utils';

const states = {
  INIT: 'INIT',
  LOADING: 'LOADING',
  COMPLETE: 'COMPLETE',
  ERROR: 'ERROR'
};
const transitions = {
  [states.INIT]: {
    loading: states.LOADING
  },
  [states.LOADING]: {
    success: states.COMPLETE,
    error: states.ERROR
  },
  [states.ERROR]: {
    loading: states.LOADING,
    wait_for_destination: states.WAITING_FOR_DESTINATION
  },
  [states.COMPLETE]: {
    loading: states.LOADING
  }
};

function reducer(prev, action) {
  const nextState = transitions[prev.value][action.transition];
  if (nextState) {
    return {
      ...prev,
      value: nextState,
      history: prev.value,
      ...action.payload
    };
  }
  return prev;
}

function useQuery({ getData, fetchData }, deps = []) {
  useEffect(() => {
    if (!fetchData) {
      return;
    }
    getData();
  }, [fetchData, getData]);
}

export function useSubscription({
  firstName,
  lastName,
  origin,
  email,
  phoneNumber,
  prePopulation,
  meta,
  integrationSettings,
  getSubscription,
  fetchData,
  setFetchData,
  pageContext
}) {
  let initialState = states.INIT;
  const [{ value: state, data: subscriptionInfo, history }, dispatch] = useReducer(reducer, {
    value: initialState,
    data: {},
    history: undefined
  });

  function match(stateValue) {
    if (isSSR() && stateValue === 'SKELETON') {
      return true;
    }
    return stateValue === state || (state === states.LOADING && history === stateValue);
  }

  const getData = () => {
    if (transitions[state].loading) {
      dispatch({ transition: 'loading' });
    }
    if (fetchData) {
      setFetchData(false);
      return getSubscription(
        {
          ...prePopulation,
          name: `${firstName} ${lastName}`,
          origin: origin.value,
          email,
          phoneNumber: Boolean(phoneNumber) ? `+${phoneNumber}` : '',
          ConsentToTrack: 'No'
        },
        meta,
        integrationSettings,
        pageContext
      )
        .then((_data) => {
          dispatch({ transition: 'success', payload: { data: _data } });
        })
        .catch((err) => {
          dispatch({ transition: 'error', payload: { data: { success: false } } });
          console.error(err);
          throw err;
        });
    }
  };

  useQuery({ getData, fetchData }, []);

  return {
    subscriptionInfo,
    match,
    retry: () => {
      setFetchData(true);
      getData();
    }
  };
}
